import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { CclDrawerService, CclNavbarFooterService, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../../modules/shared/services/catalog.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { cloneDeep } from "lodash";

import { Subscription } from "rxjs";
import { UnsavedChangesDeactivate } from "../../../../can-deactivate";

@Component({
    selector: "app-additonal-setting-page",
    templateUrl: "./additonal-setting-page.view.html",
    styleUrls: []
})
export class AdditionalSettingPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    options:any = {
        enableLiveAutocompletion: true,
        enableBasicAutocompletion: true,
        enableSnippets: true
    };
    constructor(
        private drawerService: CclDrawerService,
        private _flashMessagesService: FlashMessagesService,
        public sharedService: SharedService,
        private catalogService: CatalogService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService
    ) {
        super(sharedService);
        this.subscription = this.messageService
            .getMessage()
            .subscribe((message) => this.saveAdditionalSetting(message));
    }

    additionalSetting: any = {};
    additionalSettingObj: any = {};
    catalogLayoutConfig: any = {};

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            if (
                this.sharedService.catalogLayoutConfig.vipUnit == "card" ||
                this.sharedService.catalogLayoutConfig.vipUnit == "list"
            ) {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "";
            } else {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "";
            }
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-additional-setting";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-additional-setting";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.sharedService.currentLayoutSection = "additional-setting";
        this.additionalSettingObj = this.sharedService.configs[
            this.sharedService.configTypes.ADDITIONAL_SETTING_CONFIG
        ];
        if (this.additionalSettingObj == null || this.additionalSettingObj.id == null) {
            this.additionalSettingObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.ADDITIONAL_SETTING_CONFIG
            };
        } else {
            this.additionalSetting = JSON.parse(this.additionalSettingObj.config);
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.additionalSetting);
        this.sharedService.changedData = this.additionalSetting;
    }
    saveAdditionalSetting(message) {
        if (message.text == "save-additional-setting" || message.text == "save-next-additional-setting") {
            this.additionalSettingObj.config = JSON.stringify(this.additionalSetting);
            this.catalogService.saveSetupConfig(this.additionalSettingObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.originalData = cloneDeep(this.additionalSetting);
                this.sharedService.changedData = this.additionalSetting;

                this.additionalSettingObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[
                    this.sharedService.configTypes.ADDITIONAL_SETTING_CONFIG
                ] = this.additionalSettingObj;
                this._flashMessagesService.show("Additional Settings saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-additional-setting") {
                    this.messageService.sendMessage("attendee-preview");
                }
            });
        } else if (message.text == "apply-tab-config") {
            this.additionalSetting = cloneDeep(this.sharedService.tabsConfig);
            this.sharedService.changedData = this.additionalSetting;
            this.drawerService.hideDrawer();
        }
    }

    clickEdit(item) {
        this.drawerService.toggleDrawer("small");
        let url = "config-drawer/filter-config";
        this.sharedService.navigateToOutlet("drawer", url);
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }
}
